import React from 'react';
import { Sun, Volume2, Home, Sparkles } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-12 md:py-16 bg-warm-100" data-id="element-162">
      <div className="max-w-4xl mx-auto px-4" data-id="element-163">
        <div className="text-center mb-8" data-id="element-164">
          <div className="inline-flex items-center gap-2 bg-gold-500/10 text-gold-600 px-4 py-2 rounded-full text-sm font-medium mb-4" data-id="element-165">
            <Sparkles className="w-4 h-4" data-id="element-166" />
            <span data-id="element-167">El descubrimiento</span>
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-text-dark mb-3" data-id="element-168">
            Por qué tu bebé realmente no duerme
          </h2>
          <p className="text-text-body max-w-2xl mx-auto" data-id="element-169">
            Los bebés en Colombia tienen patrones de activación distintos. La
            luz tropical, la temperatura y el ruido urbano son{' '}
            <strong data-id="element-170">3 veces mayores</strong> que donde se crearon los métodos
            populares.
          </p>
        </div>

        <div className="bg-white p-6 md:p-8 rounded-2xl shadow-md" data-id="element-171">
          <h3 className="text-xl font-bold text-primary-600 text-center mb-6" data-id="element-172">
            El Método de Ritmos Circadianos Tropicales
          </h3>

          <div className="space-y-4" data-id="element-173">
            <div className="flex items-center gap-4 p-4 bg-warm-100 rounded-xl" data-id="element-174">
              <div className="bg-primary-100 p-2 rounded-full shrink-0" data-id="element-175">
                <Sun className="w-5 h-5 text-primary-600" data-id="element-176" />
              </div>
              <div data-id="element-177">
                <span className="text-text-muted line-through text-sm" data-id="element-178">
                  No suprime el entorno.
                </span>
                <p className="font-semibold text-text-dark" data-id="element-179">
                  Lo usa a tu favor.
                </p>
              </div>
            </div>

            <div className="flex items-center gap-4 p-4 bg-warm-100 rounded-xl" data-id="element-180">
              <div className="bg-primary-100 p-2 rounded-full shrink-0" data-id="element-181">
                <Volume2 className="w-5 h-5 text-primary-600" data-id="element-182" />
              </div>
              <div data-id="element-183">
                <span className="text-text-muted line-through text-sm" data-id="element-184">
                  No ignora el ruido.
                </span>
                <p className="font-semibold text-text-dark" data-id="element-185">
                  Lo convierte en señal de sueño.
                </p>
              </div>
            </div>

            <div className="flex items-center gap-4 p-4 bg-warm-100 rounded-xl" data-id="element-186">
              <div className="bg-primary-100 p-2 rounded-full shrink-0" data-id="element-187">
                <Home className="w-5 h-5 text-primary-600" data-id="element-188" />
              </div>
              <div data-id="element-189">
                <span className="text-text-muted line-through text-sm" data-id="element-190">
                  No pide que cambies tu casa.
                </span>
                <p className="font-semibold text-text-dark" data-id="element-191">
                  Ajusta la rutina a tu casa.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}